import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq-infrigement',
  templateUrl: './faq-infrigement.component.html',
  styleUrls: ['./faq-infrigement.component.css']
})
export class FaqInfrigementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
